// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","booking-wizard":"v_b2","bookingWizard":"v_b2","block":"v_b3","button":"v_bv"};